import styled from 'styled-components'

export const Container = styled.div`
  position: relative;
  width: 100%;

  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
`
